export default __webpack_public_path__ + "assets/fonts/971531a79e3971e95141772ef2408ba5.woff2";